const footerInfo = {
    phone:"(620) 555-0127",
    email:"travo@example.com",
    adrees:"3891 Ranchview Dr. Richardson, California 62639",
    img:[]
  }
  const footerList =[
    {
      id:1,
      list:[
        'home','Popular products','popular region','review','Recommended'
      ]
    },
    {
      id:2,
      list:[
        'Product content','review','Product Recommendation'
      ]
    },
    {
      id:3,
      list:[
        'About Us','Service Introduction','Quality review','FAQ','Contact Us'
      ]
    },
    {
      id:4,
      list:[
        'book now','Fill in the information'
      ]
    },
  ]
  const footerInfo1 = {
    desc1:'Copyright © 2025 Vacasky. All rights reserved.',
    desc2:'Privacy Policy  |  Terms & Condition'
  }
  
  export default{
    footerInfo,
    footerList,
    footerInfo1
  }